// extracted by mini-css-extract-plugin
module.exports = {"info":"infoLine_info_1ZKrQeU","infoPoint":"infoLine_infoPoint_KyD82hk","label":"infoLine_label_2ivh9q4","dot":"infoLine_dot_3c1vvFZ"};